module.exports = __webpack_public_path__ + "static/service_en_bg@3x-8e6ebca7e1d63bc8274b52b004c5b6ea.png";